<template>
  <div>
    <v-flex md12>
      <v-row>
        <v-col cols="6" class="pa-1">
          <span class="pl-2 pt-2 pr-3 mb-2 headline">
            {{ customer.name || '' }}
          </span>
        </v-col>
        <v-col cols="6" class="pa-1 text-right">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark v-bind="attrs" v-on="on">
                {{ $t('message.common.new') }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-for="(item, index) in types.filter(x => x.value !== 'rest_order')" :key="index" :to="`/orders/actions?type=${item.value}&customerid=${customerId}`">
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
      <v-tabs background-color="primary" grow dark>
        <v-tab :to="`/customers/edit/${customerId}/view`">
          <v-icon color="white">mdi-account-details</v-icon>
          <span class="ml-1">{{ $t('message.order.details') }}</span>
        </v-tab>
        <v-tab :to="`/customers/edit/${customerId}/documents`">
          <v-icon color="white" class="mdi-rotate-315">mdi-attachment</v-icon>
          <span class="ml-1">{{ $t('message.product.attachments') }}</span>
        </v-tab>
        <v-tab :to="`/customers/edit/${customerId}/contacts`">
          <v-icon color="white">mdi-account-multiple</v-icon>
          <span class="ml-1">{{ $t('message.customer.contacts') }}</span>
        </v-tab>
        <v-tab :to="`/customers/edit/${customerId}/address`">
          <v-icon color="white">mdi-map-marker</v-icon>
          <span class="ml-1">{{ $t('message.customer.address') }}</span>
        </v-tab>
        <v-tab :to="`/customers/edit/${customerId}/orders`">
          <v-icon color="white">mdi-cart-plus</v-icon>
          <span class="ml-1">{{ $t('message.layout.orderOrOffer') }}</span>
        </v-tab>
        <v-tab v-if="customer.issupplier" :to="`/customers/edit/${customerId}/addons`">
          <v-icon color="white">mdi-ticket-percent</v-icon>
          <span class="ml-1">{{ $t('message.customer.addons') }}</span>
        </v-tab>
        <v-tab :to="`/customers/edit/${customerId}/netprices`">
          <v-icon color="white">mdi-currency-usd</v-icon>
          <span class="ml-1">{{ $t('message.order.netprice') }}</span>
        </v-tab>
      </v-tabs>
    </v-flex>
    <v-progress-linear class="mt-2" indeterminate v-if="loading"></v-progress-linear>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  data () {
    return {
      customerId: this.$route.params.crm_id,
      customer: {},
      loading: false
    }
  },
  computed: {
    types () {
      return [{
        name: this.$t('message.layout.sales'),
        value: 'sales'
      }, {
        name: this.$t('message.layout.offer'),
        value: 'offer'
      }, {
        name: this.$t('message.layout.order'),
        value: 'order'
      }, {
        name: this.$t('message.orders.restOrder'),
        value: 'rest_order'
      }]
    }
  },
  mounted () {
    this.getCustomerData()
  },
  methods: {
    getCustomerData () {
      this.$_executeApi('get', `customers/${this.$route.params.crm_id}`)
        .then(response => {
          this.customer = response.data || {}
        })
    }
  }
}
</script>
